<!-- 
 头像下拉中个人中心
 1.左侧的tabName标识从公共仓库获取
 -->
<template>
  <div>
    <el-tabs
      v-model="selectTabs"
      :tab-position="tabPosition"
      type="border-card"
      @tab-click="handleTabClick"
    >
      <!-- 个人中心页面 -->
      <el-tab-pane label="个人中心" name="1">
        <router-view></router-view>
      </el-tab-pane>

      <el-tab-pane label="消息通知" name="2">
        <router-view></router-view>
      </el-tab-pane>
      <el-tab-pane label="积分兑换" name="3">
        <router-view></router-view>
      </el-tab-pane>
      <el-tab-pane label="审核记录" name="4">
        <router-view></router-view>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
   
   <script>
//  导入vuex中mapState
import { setTimeout } from "core-js";
import { mapState, mapMutations } from "vuex";

// 导入个人中心组件
export default {
  name: "userIndex",
  components: {
    // UserInfo:UserInfo
  },
  data() {
    return {
      tabPosition: "left",
      selectTabs: "", //选中的标签，从公共仓库获取
    };
  },

  created() {
    setTimeout(() => {
      this.selectTabs = this.userPullDownData.TabPaneName;
    console.log("进入到主index页面" + this.selectTabs);
    }, 0);  
  },

  // 使用计算属性
  computed: {
    ...mapState(["userPullDownData"]),
  },
  methods: {
    // 公共仓库中的方法
    ...mapMutations(["changeTabPaneName"]),

    // 点击个人中心调用
    handleTabClick(tab) {
      //  根据获取tab标签，去调用不同的方法
      if (tab.name === "1") {
        // 个人中心跳转
        const targetRoute = "/userIndex/userInfo";
        if (this.$route.path !== targetRoute) {
          this.$router.push(targetRoute);
        }

        // 更改store仓库中的标识值
        this.changeTabPaneName("1");
      } else if (tab.name === "2") {
        // 消息通知跳转
        const targetRoute = "/userIndex/message";
        if (this.$route.path !== targetRoute) {
          this.$router.push(targetRoute);
        }

        // 更改store仓库中的标识值
        this.changeTabPaneName("2");
      } else if (tab.name === "3") {
        // 积分兑换跳转
        const targetRoute = "/userIndex/credits";
        if (this.$route.path !== targetRoute) {
          this.$router.push(targetRoute);
        }

        // 更改store仓库中的标识值
        this.changeTabPaneName("3");
      } else if (tab.name === "4") {
        // 积分兑换跳转
        const targetRoute = "/userIndex/approved";
        if (this.$route.path !== targetRoute) {
          this.$router.push(targetRoute);
        }

        // 更改store仓库中的标识值
        this.changeTabPaneName("4");

        console.log(
          "获取的store中的值：" + JSON.stringify(this.userPullDownData)
        );
      }
    },
  },
};
</script>
   
   <style scoped>
</style>